import type { HomeCardsConfig } from '../../components/home-cards.tsx';

/** Cartões da Visão geral: Dados Mestres (ADR 0097). */
export const MASTERDATA_CARDS: HomeCardsConfig = {
  queryKey: 'masterdata',
  endpoint: '/masterdata/home-cards',
  consultTo: '/masterdata/pending',
  cards: [
    {
      id: 'cost_centers_without_approver',
      section: 'pending',
      title: 'masterData.home.noApprover.title',
      criterion: 'masterData.home.noApprover.criterion',
      unit: 'masterData.home.units.costCenters',
      link: { to: '/governance/cost-centers', search: { filter: 'no_approver' } },
      attention: true,
    },
    {
      id: 'employees_without_manager',
      section: 'pending',
      title: 'masterData.home.noManager.title',
      criterion: 'masterData.home.noManager.criterion',
      unit: 'masterData.home.units.employees',
      link: { to: '/people/employees', search: { filter: 'no_manager' } },
    },
    {
      id: 'blocked_suppliers',
      section: 'pending',
      title: 'masterData.home.blocked.title',
      criterion: 'masterData.home.blocked.criterion',
      unit: 'masterData.home.units.suppliers',
      link: { to: '/partners', search: { status: 'blocked' } },
      attention: true,
    },
    {
      id: 'required_documents',
      section: 'pending',
      title: 'masterData.home.documents.title',
      criterion: 'masterData.home.documents.criterion',
      unit: 'masterData.home.units.documents',
      link: { to: '/partners/documents', search: { filter: 'required' } },
      attention: true,
      detailPrefix: 'partners.documents.situations',
      detailOrder: ['missing', 'requested', 'in_review', 'rejected', 'expired'],
    },
    {
      id: 'suppliers_in_homologation',
      section: 'pending',
      title: 'masterData.home.homologation.title',
      criterion: 'masterData.home.homologation.criterion',
      unit: 'masterData.home.units.suppliers',
      link: { to: '/partners', search: { status: 'pending' } },
    },
    {
      id: 'import_pending',
      section: 'pending',
      title: 'masterData.home.importPending.title',
      criterion: 'masterData.home.importPending.criterion',
      unit: 'masterData.home.units.items',
      link: { to: '/structure/import-pending', search: { status: 'open' } },
    },
  ],
};
